import React from "react";
import PropTypes from 'prop-types';
import { TextField } from "@material-ui/core";

import "../styles.css"

export default function BasicInfo(props) {
    const handleChange = (event) => {
        props.setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
    };

    return (
        <>
            <div className="titles">Descrição da Ocorrência</div>
            <div className="fundo">
                <div className="rowForm">
                    <div className="autoUm">
                        <TextField
                            multiline
                            margin="dense"
                            id="descricao"
                            label="Descrição"
                            value={props.values.descricao}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

BasicInfo.propTypes = {
    values: PropTypes.object,
    setValues: PropTypes.func
};
